import React from 'react'
import { hooks } from '@front/volcanion'

import { Box } from '@mui/material'
import { FormTable, TableHeader, TableRow } from '@front/squirtle'

import Header from './Header'
import Row from './Row'

const Table = ({ model_name, hide }) => {
  const DEFAULT_PAGE_SIZE = hooks.useRelayConstant('DEFAULT_PAGE_SIZE')

  return (
    <Box sx={{ display: hide ? 'none' : 'block' }}>
      <FormTable
        model_name={model_name}
        name={`staff_history_${model_name}_list`}
        config={{
          search_id: `staff_history_${model_name}`,
          enableCount: true,
          default_limit: DEFAULT_PAGE_SIZE
        }}
      >
        <TableHeader><Header /></TableHeader>
        <TableRow><Row /></TableRow>
      </FormTable>
    </Box>
  )
}

export default React.memo(Table)
